import { FC } from "react";
import styled from "styled-components";
import { useSwiper } from "swiper/react";

const ArrowButton = styled.div`
	width: 20px;
	height: 20px;
	border-radius: 50%;
	background-color: ${props => (props.theme.colors.whiteVitat || "#eadced")};
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
	align-content: flex-start;
	margin: 8px;
	padding: 2px;
	position: absolute;
	top: 16px;
	z-index: 10;
`;

const ArrowLeftButton = styled(ArrowButton)`
	left: 0;
`;

const ArrowRightButton = styled(ArrowButton)`
	right: 0;
`;

interface SliderNavigationButtonProps {
	prev: boolean;
}

const SliderNavigationButton: FC<SliderNavigationButtonProps> = ({ prev }) => {
	const swiper = useSwiper();

	return prev ? (
		<ArrowLeftButton onClick={() => swiper.slidePrev()}>
			<svg width={10} height={10} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.6006 0.231232C10.1331 0.53954 10.1331 1.03941 9.6006 1.34772L3.29211 5L9.6006 8.65228C10.1331 8.96059 10.1331 9.46046 9.6006 9.76877C9.06807 10.0771 8.20466 10.0771 7.67213 9.76877L0.3994 5.55824C-0.133133 5.24993 -0.133133 4.75007 0.3994 4.44176L7.67213 0.231232C8.20466 -0.0770772 9.06807 -0.0770772 9.6006 0.231232Z"
					fill="#382868"
				/>
			</svg>
		</ArrowLeftButton>
	) : (
		<ArrowRightButton onClick={() => swiper.slideNext()}>
			<svg width={10} height={10} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M0.3994 0.231232C0.931933 -0.0770772 1.79534 -0.0770772 2.32787 0.231232L9.6006 4.44176C10.1331 4.75007 10.1331 5.24993 9.6006 5.55824L2.32787 9.76877C1.79534 10.0771 0.931933 10.0771 0.3994 9.76877C-0.133133 9.46046 -0.133133 8.96059 0.3994 8.65228L6.70789 5L0.3994 1.34772C-0.133133 1.03941 -0.133133 0.53954 0.3994 0.231232Z"
					fill="#382868"
				/>
			</svg>
		</ArrowRightButton>
	);
};

export default SliderNavigationButton;
